import { RECEIVE_FILES, REMOVE_FILE, REQUEST_FILES } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_FILES:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_FILES: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return {
                ...state,
                ...data,
                items,
            }
        }

        case REMOVE_FILE: {
            const { items: currentItems } = state
            const { id } = data

            const items = currentItems.filter((o) => o.id !== id)

            return {
                ...state,
                items,
            }
        }

        default:
            return state
    }
}
